<template>
    <BasePopUp v-if="showModal" @detailsClosed="closeConfirmRequested">
        <div class="modal-body-container">
            <h4 class="text-center mt-4">{{title}}</h4>                
            <CDataTable :items="comments" :fields="fields" :loading="loading">
                <template #actions="{item}">
                    <td class="py-2">
                        <CButton class="mr-2" color="primary" variant="outline" square size="sm" @click="removeComment(item)">
                        {{$t('remove')}}
                        </CButton>
                    </td>
                </template>
            </CDataTable>
            <CButton type="button" class="mb-4 btn btn-primary align-self-center" @click="closeConfirmRequested">{{ $t('close') }}</CButton>
        </div>
    </BasePopUp>
</template>

<script>
import BasePopUp from './BasePopUp.vue';
import { mapState, mapActions } from 'vuex'

export default {
    extends: BasePopUp,
    components: {BasePopUp},
    computed:
    {
        fields: function()
        {
            return [
            { key: 'date', label: this.$i18n.t('date'), sortable: true  },
            { key: 'username', label: this.$i18n.t('username') },
            { key: 'description', label: this.$i18n.t('description'), sortable: true },
            { key: 'actions', label: this.$i18n.t('actions')}
        ];
        },
        actions: function()
        {
            return [{ key: 'remove', label: this.$i18n.t('remove') }];
        },
        ...mapState('comments', ['getCommentsForOccurenceOutput']),
        ...mapState('comments', ['deleteCommentByIdOutput']),
        comments: function()
        {
            var result = [];

            if(this.getCommentsForOccurenceOutput && Array.isArray(this.getCommentsForOccurenceOutput))
            {
                result = this.getCommentsForOccurenceOutput;
                result.forEach(comment =>
                {
                    comment.date = comment.date.replace("T", " ");
                    comment.username = `${comment.user.firstName} ${comment.user.lastName} (${comment.user.email})`;
                })
            }

            return result;
        },
        loading: function()
        {
            return !this.getCommentsForOccurenceOutput || history.deleteCommentByIdOutput === null;
        }
    },
    methods:{
        ...mapActions('comments', ['getCommentsForOccurence']),
        ...mapActions('comments', ['deleteCommentById']),
        closeConfirmRequested(event)
        {       
            this.$emit("closeConfirmRequested");
        },
        removeComment(item){
            if(confirm(this.$i18n.tc('confirmRemoveFromUser', `${item.username}`, { name: `${item.username} }` }))){
                this.deleteCommentById(item.id);
            }
        },
    },
    props:{
        title:
        {
            type: String,
            default: ''
        },
        id:
        {
            type: Number,
            default: ''
        },
    },
    mounted: function()
    {
        if(this.id)
        {
            this.getCommentsForOccurence(this.id);
        }
    },
    watch: 
    {
        id: function()
        {
            this.getCommentsForOccurence(this.id);
        },
        deleteCommentByIdOutput: function(val)
        {
            if(val !== null)
            {
                this.getCommentsForOccurence(this.id);
            }
        }
    }
}
</script>

<style scoped>
    .modal-body-container
    {
        background-color: #fff;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        padding: 10px;
        border-radius: 10px;    
        min-height: 200px;
    
    }
</style>